import { Injectable } from '@angular/core';
import { AuthApiAccountService } from '../api/auth/auth-api-account.service';
import { Account } from '../api/auth/model/account.interface';
import { LocalStorageService } from './local-storage.service';


@Injectable({ providedIn: 'root' })
export class AccountStoreService {

  private readonly accountIdKey = 'currectAccID';

  private account: Account = undefined;

  constructor(
    private authApiAccountService: AuthApiAccountService,
    private localStorageService: LocalStorageService,
  ) {
  }

  setAccount(account: Account): void {
    this.account = account;
  }

  setAccountById(accountId: string) {
    this.localStorageService.setItem(this.accountIdKey, accountId);
    this.authApiAccountService.readAccount$(accountId).subscribe(account => {
      this.account = account;
    });
  }

  getAccountId(): string | undefined {
    return this.localStorageService.getItem(this.accountIdKey);
  }

  getAccount(): Account | undefined {
    return this.account;
  }

  clean(): void {
    this.account = undefined;
  }
}
